"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Recurrence_1 = require("../Recurrence");
var TimeHhMm_1 = require("../TimeHhMm");
var TimePicker_1 = require("../controls/TimePicker");
var WeekDayPicker_1 = require("../controls/WeekDayPicker");
var TimeZoneDisplay_1 = require("../controls/TimeZoneDisplay");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../../../gen-src/Localize");
var DayPickerStyle = { textAlign: 'left', flex: '1 2 400px' };
var TimePickerCssStyle = { flex: '1 2 165px', marginTop: '18px', marginLeft: '24px', marginBottom: '18px' };
var TimeZoneCssStyle = { flex: '1 2 400px', marginTop: '18px' };
var Typography = widgets_1.TabStyles.Typography;
var BentonLabelTextStyle = {
    display: 'block',
    boxSizing: 'border-box',
    position: 'relative',
    fontSize: Typography.Sizing.Default,
    fontWeight: 'normal',
    color: Typography.Color.Primary,
    lineHeight: '21px'
};
var WeeklyRecurrencePane = /** @class */ (function (_super) {
    __extends(WeeklyRecurrencePane, _super);
    function WeeklyRecurrencePane(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.timeChangedHandler = function (time) { return _this.onStartTimeChange(time); };
        _this.weekDaysChangedHandler = function (newDayChoiceIds) { return _this.onWeekDaysChange(newDayChoiceIds); };
        _this.weekDays = Recurrence_1.getWeekdayInfos();
        return _this;
    }
    WeeklyRecurrencePane.prototype.onStartTimeChange = function (time) {
        var newDetails = __assign({}, this.props.recurrenceDetails, { startTime: time.toNumber() });
        this.props.recurrenceDetailsChangedCallback(newDetails);
    };
    WeeklyRecurrencePane.prototype.onWeekDaysChange = function (weekDayIds) {
        var newDetails = __assign({}, this.props.recurrenceDetails, { recurrenceDaysOfWeek: weekDayIds });
        this.props.recurrenceDetailsChangedCallback(newDetails);
    };
    WeeklyRecurrencePane.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(TimePicker_1.TimePicker, { caption: Localize_1.Messages.RecurrenceCaptionAt(), onTimeChange: this.timeChangedHandler, selectedValue: TimeHhMm_1.TimeHhMm.fromNumber(this.props.recurrenceDetails.startTime), style: TimePickerCssStyle, type: this.props.type, minuteInterval: Recurrence_1.getStartEndTimeMinuteInterval(this.props.type) }),
            React.createElement("div", { style: DayPickerStyle },
                React.createElement("div", { style: BentonLabelTextStyle }, Localize_1.Messages.RecurrenceCaptionOn()),
                React.createElement(WeekDayPicker_1.WeekDayPicker, { weekDays: this.weekDays, testId: this.props.testWeekDayPickerId, selectedDayIds: this.props.recurrenceDetails.recurrenceDaysOfWeek, onSelectionChanged: this.weekDaysChangedHandler })),
            React.createElement("div", { style: TimeZoneCssStyle },
                React.createElement(TimeZoneDisplay_1.TimeZoneDisplay, { timeZoneDetails: this.props.timeZoneDetails, label: Localize_1.Messages.RecurrenceTimeZone(), onClick: this.props.onTimeZoneClick }))));
    };
    return WeeklyRecurrencePane;
}(React.Component));
exports.WeeklyRecurrencePane = WeeklyRecurrencePane;
//# sourceMappingURL=WeeklyRecurrencePane.js.map